import { IAPIResponse, IAttributeCreateResponse } from "../interfaces/api";
import { IAttributesInfo } from "../interfaces/attributes";
import { ICoreElementProperties } from "../interfaces/elements";
import { config } from "../utils/config";
import { log } from "../utils/logger";
import { formatURL } from "../utils/utils";

export const getAttributesList = async <Type>(lanid: string): Promise<IAPIResponse<Array<Type>>> => {
    const selectedURL = `${formatURL(config.GamificationEngineBaseURL)}api/v1/game/attribute/list?userName=${lanid}`;
    const headers = new Headers();

    log.debug(`getAttributesList HTTP request URL: ${selectedURL}`);

    try {
        const apiResponse: Response = await fetch(selectedURL, { method: 'GET', headers });

        return {
            status: apiResponse.ok,
            response: await apiResponse.json(),
            error: null,
        }
    } catch (error: any) {
        return {
            status: false,
            response: null,
            error,
        }
    }
}

export const createAttribute = async (lanid: string, attributeInfo: IAttributesInfo): Promise<IAPIResponse<IAttributeCreateResponse>> => {
    const selectedURL = `${formatURL(config.GamificationEngineBaseURL)}api/v1/game/attribute/create?userName=${lanid}`;
    const headers = new Headers();
    headers.append("Content-Type", "application/json");

    log.debug(`createAttribute HTTP request URL: ${selectedURL}`);

    try {
        const apiResponse: Response = await fetch(selectedURL, { method: 'POST', headers, body: JSON.stringify(attributeInfo) });

        return {
            status: apiResponse.ok,
            response: await apiResponse.json(),
            error: null,
        }
    } catch (error: any) {
        return {
            status: false,
            response: null,
            error,
        }
    }
}

export const getAttributeProperties = async (): Promise<IAPIResponse<ICoreElementProperties>> => {
    const selectedURL = `${formatURL(config.GamificationEngineBaseURL)}api/v1/game/attribute/properties`;
    const headers = new Headers();

    log.debug(`getAttributeProperties HTTP request URL: ${selectedURL}`);

    try {
        const apiResponse: Response = await fetch(selectedURL, { method: 'GET', headers });

        return {
            status: apiResponse.ok,
            response: await apiResponse.json(),
            error: null,
        }
    } catch (error: any) {
        return {
            status: false,
            response: null,
            error,
        }
    }
}

export const deleteAttribute = async (lanId: string, attributeId: number): Promise<IAPIResponse<null>> => {
    const selectedURL = `${formatURL(config.GamificationEngineBaseURL)}api/v1/game/attribute/delete/${attributeId}?userName=${lanId}`;
    const headers = new Headers();

    log.debug(`deleteAttribute HTTP request URL: ${selectedURL}`);

    try {
        const apiResponse: Response = await fetch(selectedURL, { method: 'DELETE', headers });

        return {
            status: apiResponse.ok,
            response: await apiResponse.json(),
            error: null,
        }
    } catch (error: any) {
        return {
            status: false,
            response: null,
            error,
        }
    }
}